import { Button, Divider, Grid, TextField, Typography } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SaveIcon from '@mui/icons-material/Save';
import { useState } from 'react';
import { createItem } from '../../services/Item';
import { useNotify } from 'react-admin';
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';

const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid Color.Main',
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  color: Color.Button,
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};

export const ItemCreate = ({ handleBack, categoryId }) => {
  const notify = useNotify();
  const initState = {
    categoryId: categoryId,
    name: null,
    description: null,
    price: null,
    quantity: null,
    unit: null,
    attributes: JSON.stringify({
      image:
        'https://cdn.imgbin.com/2/12/3/imgbin-birthday-cake-torte-fruitcake-chocolate-cake-wedding-cake-chocolate-cake-T3SKpQUE7VFgh4fCRZR0Uk2mP.jpg',
      color: 'blue',
    }),
  };
  const initValidationState = { status: false, message: ' ' };
  const [itemCreate, setItemCreate] = useState(initState);
  const [errorName, setErrorName] = useState(initValidationState);
  const [errorPrice, setErrorPrice] = useState(initValidationState);
  const [errorQuantity, setErrorQuantity] = useState(initValidationState);
  const [errorUnit, setErrorUnit] = useState(initValidationState);

  const handleChangeName = (e) => {
    setErrorName(initValidationState);
    setItemCreate((prev) => ({ ...prev, name: e.target.value.trim() }));
  };
  const handleChangeDescription = (e) => {
    setItemCreate((prev) => ({ ...prev, description: e.target.value.trim() }));
  };
  const handleChangePrice = (e) => {
    setErrorPrice(initValidationState);
    setItemCreate((prev) => ({ ...prev, price: parseInt(e.target.value) }));
  };
  const handleChangeQuantity = (e) => {
    setErrorQuantity(initValidationState);
    setItemCreate((prev) => ({ ...prev, quantity: parseInt(e.target.value) }));
  };
  const handleChangeUnit = (e) => {
    setErrorUnit(initValidationState);
    setItemCreate((prev) => ({ ...prev, unit: e.target.value.trim() }));
  };

  //validate data create
  const validateName = () => {
    if (itemCreate.name === null || itemCreate.name === '') {
      setErrorName({
        ...errorName,
        status: true,
        message: 'Please fill in this field',
      });
      return false;
    }
    return true;
  };
  const validatePrice = () => {
    if (
      itemCreate.price === null ||
      isNaN(itemCreate.price) ||
      itemCreate.price < 0 ||
      itemCreate.price > 2147483648
    ) {
      setErrorPrice({ ...errorPrice, status: true, message: 'Invalid price' });
      return false;
    }
    return true;
  };
  const validateQuantity = () => {
    if (
      itemCreate.quantity === null ||
      isNaN(itemCreate.quantity) ||
      itemCreate.quantity < 0 ||
      itemCreate.quantity > 2147483648
    ) {
      setErrorQuantity({
        ...errorQuantity,
        status: true,
        message: 'Invalid quantity',
      });
      return false;
    }
    return true;
  };
  const validateUnit = () => {
    if (itemCreate.unit === null || itemCreate.unit === '') {
      setErrorUnit({
        ...errorUnit,
        status: true,
        message: 'Please fill in this field',
      });
      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (
      validateName() &&
      validatePrice() &&
      validateQuantity() &&
      validateUnit()
    ) {
      createItem(itemCreate)
        .then((res) => {
          notify('Create item successfully!', { type: 'success' });
          handleBack();
        })
        .catch((err) => {
          const error = err.response.errors[0];
          notify(error.message, { type: 'error' });
        });
    } else {
      validateName();
      validatePrice();
      validateQuantity();
      validateUnit();
    }
  };
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          mb: 1,
        }}
      >
        <Button
          endIcon={<DescriptionIcon sx={{ color: Color.Main }} />}
          sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
          size="medium"
        >
          <Typography variant="h3">Create Item</Typography>
        </Button>
      </Grid>
      <Divider sx={{ width: '100%' }} />
      <Grid
        item
        container
        xs={12}
        spacing={2}
        sx={{
          mt: 1,
          px: 6,
          pb: 3,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid item xs={12} md={5}>
          <TextField
            error={errorName.status}
            label="Name"
            required
            onChange={(e) => handleChangeName(e)}
            helperText={errorName.message}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            label="Description"
            onChange={(e) => handleChangeDescription(e)}
            helperText=" "
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            error={errorPrice.status}
            required
            label="Price"
            onChange={(e) => handleChangePrice(e)}
            type="number"
            helperText={errorPrice.message}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            required
            label="Quantity"
            onChange={(e) => handleChangeQuantity(e)}
            type="number"
            error={errorQuantity.status}
            helperText={errorQuantity.message}
          />
        </Grid>
        <Grid item xs={12} md={10}>
          <TextField
            required
            label="Unit"
            onChange={(e) => handleChangeUnit(e)}
            sx={{ width: 'calc(50% - 8px)' }}
            error={errorUnit.status}
            helperText={errorUnit.message}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 2,
          backgroundColor: '#f5f5f5',
          padding: 1.5,
          borderRadius: 3,
        }}
      >
        <Button
          startIcon={<KeyboardBackspaceIcon />}
          onClick={handleBack}
          sx={backButton}>
          Back
        </Button>
        <Button
          disabled={JSON.stringify(itemCreate) === '{}'}
          startIcon={<SaveIcon />}
          onClick={handleSave}
          sx={saveButton}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
};
